<template lang="pug">
  .edit-user-form.columns
    b-loading(:active="isLoading")

    .column.is-6: .box

      b-field(label="Роль")
        | {{ value.role.title }}

      select-platform(
        v-if="!value.isAdmin && this.canEdit()",
        label="Платформа*",
        v-model="value.platform_id",
        :data.sync="value.platform"
      )

      b-field(v-else-if="!value.isAdmin", label="Платформа")
        | {{ value.platform.name }}

      div(v-if="this.canEdit()")
        b-field(label="Статус*")
          b-select(v-model="value.status")
            option(v-for="(status, key) in value.statuses" :value="key" :key="key")
              | {{ status.name }}

        b-field(label="Фамилия*", :type="errors && errors.last_name ? 'is-danger' : ''", :message="errors.last_name")
          b-input(v-model="value.last_name")
        b-field(label="Имя*", :type="errors && errors.first_name ? 'is-danger' : ''", :message="errors.first_name")
          b-input(v-model="value.first_name")
        b-field(label="Отчество", :type="errors && errors.patronymic ? 'is-danger' : ''", :message="errors.patronymic")
          b-input(v-model="value.patronymic")
        b-field(label="Email*", :type="errors && errors.email ? 'is-danger' : ''", :message="errors.email")
          b-input(v-model="value.email", type="email")

        br
        br

        div(class="control")
          b-field(label="Новый пароль", :type="errors && errors.password ? 'is-danger' : ''", :message="errors.password")
            b-input(v-model="value.password")
        p(class='help')
          | не менее 8 символов &nbsp;&nbsp;
          a(@click="this.genPassword")
            | Сгенерировать пароль

        br

        b-checkbox(v-model="value.is_send_password")
          | Отправить пароль на email

      div(v-else)

        b-field(label="Статус")
          b-icon(:icon="value.statusLabel.icon", :type="value.statusLabel.color")
          | &nbsp; {{ value.status_label }}
        b-field(v-if="value.last_name" label="Фамилия")
          | {{ value.last_name }}
        b-field(label="Имя")
          | {{ value.first_name }}
        b-field(v-if="value.patronymic" label="Отчество")
          | {{ value.patronymic }}
        b-field(label="Email")
          | {{ value.email }}

        template(v-if="value.status==='active'")
          br
          br

          div(class="control")
            b-field(label="Новый пароль", :type="errors && errors.password ? 'is-danger' : ''", :message="errors.password")
              b-input(v-model="value.password")
          p(class='help')
            | не менее 8 символов &nbsp;&nbsp;
            a(@click="this.genPassword")
              | Сгенерировать пароль

          br

          b-checkbox(v-model="value.is_send_password")
            | Отправить пароль на email

</template>

<script>
import { mapGetters } from 'vuex';
import BSelect from 'buefy/src/components/select/Select';
import SelectRole from "../components/SelectRole";
import { genPassword } from "../helpers/string";
import { ToastProgrammatic as Toast } from 'buefy';

export default {
  name: 'edit-user-form',
  components: { SelectRole, BSelect },
  props: {
    value: Object,
    errors: Object,
  },

  data: () => ({
    isLoading: true,
    label: null,
    isSuperAdmin: null,
  }),

  computed: {
    ...mapGetters(['user']),
  },

  watch: {
    'value.role_id': function (roleId) {
      this.isSuperAdmin = roleId === 1;
    },
  },

  methods: {
    canEdit() {
      return this.user.id === this.value.id || (this.user.isAdmin && !this.value.isAdmin);
    },
    genPassword() {
      this.value.password = genPassword();
    },
    afterSave() {
      Toast.open({
        type: 'is-success',
        duration: 4000,
        message: 'Данные успешно сохранены',
        queue: false,
      });
    },
  },

  created() {
    this.isLoading = false;
  },
};
</script>

<style scoped>

</style>
